export default __webpack_public_path__ + "static/media/ub-pil-90-orange-rgb.903a4a86.svg";